export default "__VITE_PUBLIC_ASSET__ad19b274__"